import fetch from '@dp/varyag-hoc-component/fetch';
import { isObject } from "../lib/util";

const createFetch = fetch.create({
   host: {
       dev: '/api',
   }
});

export default async (id) => {
    let pageData = {};
    try {
        const result = await createFetch({
            url: `/normal/page/queryInfo`,
            data: {
                id,
            },
        });
        if (isObject(result)) {
            pageData = {
                ...result
            }
        }
    } catch (e) {
        console.error(e);
    }
    return pageData;
}



// WEBPACK FOOTER //
// ./src/api/getPageData.js